<template>

  <!-- <div class="lnb-menu dp-none"> -->
  <div class="lnb-menu dp-none">
    <div class="lnb-top">
      <!-- button 영역 -->
      <div class="container clearfix">
        <div class="f-left">
          <!-- <button type="button" class="btn btn-close" @click="onMenuSelected('CLOSE_MENU');"><span class="blind">메뉴 닫기</span></button>                     -->
          <button type="button" class="btn btn-close" @click="hideMenu();"><span class="blind">메뉴 닫기</span></button>
        </div>
        <div class="f-right">
          <!-- <router-link to="/settings" class="btn btn-config"><span class="blind">설정</span></router-link> -->
          <button type="button" class="btn btn-config" @click="onMenuSelected('SETTINGS')"><span class="blind">설정</span>
          </button>
        </div>
      </div>
      <!--// button 영역 -->
      <!-- 로그인 안내 로그인 전-->
      <div v-if="(loginState == false)" class="lnb-login ">
        <p class="lnb-txt01">로그인을 하시면 더 많은 혜택을<br>받으실 수 있습니다.</p>
        <ul class="btn-group01">
          <li>
            <router-link to="/login" class="btn btn01">
              로그인
            </router-link>
          </li>
          <li>
            <router-link to="/member" class="btn btn02">
              회원가입
            </router-link>
          </li>
        </ul>
      </div>
      <!--// 로그인 안내 로그인 전 -->
      <!-- 회원정보 로그인 후-->
      <div v-else-if="(loginState == true)" class="lnb-member container">
        <p class="lnb-txt02">
          <!-- <span class="username"><strong>{{memberInfo.name}}</strong>님</span>,<br> -->

          <span class="username">
                      <strong v-if="(memberInfo.nickname != '')">{{ memberInfo.nickname }}</strong>
                      <strong v-else>{{ memberInfo.name }}</strong>
                      님</span>,<br>오늘도 공차와 함께하세요.

        </p>
        <ul class="lnb-member-info type02">
          <li>
            <router-link to="/stamp">
              <span class="info info01">{{ mainInfo.stamp }}/10</span>
            </router-link>
          </li>
          <li>
            <span class="line"></span>
            <router-link to="/coupon">
              <span class="info info02">{{ mainInfo.couponCnt }}</span>
            </router-link>
          </li>
          <li>
            <router-link to="/card">
              <span class="info info03">{{ mainInfo.cardCnt }}</span>
            </router-link>
          </li>
          <li>
            <span class="line"></span>
            <router-link to="/giftshop/main/giftbox">
              <span class="info info04">{{ mainInfo.presentCnt }}</span>
            </router-link>
          </li>
        </ul>
      </div>
      <!--// 회원정보 로그인 후-->
    </div>
    <!--메뉴 01-->
    <ul class="lnb-menu01 type02">
      <li class="li01"><a @click="onMenuSelected('ORDER')">오더</a></li>
      <li class="li02"><a @click="onMenuSelected('GIFT_SHOP')">기프트샵</a></li>
      <li class="li03"><a @click="onMenuSelected('FIND_STORE')">매장찾기</a></li>
      <!-- <li class="li04"><a @click="onMenuSelected('SHOW_MENU')">메뉴보기</a></li> -->
      <li class="li05"><a @click="onMenuSelected('ORDER_HISTORY')">주문내역</a></li>
      <li class="li06"><a @click="onMenuSelected('EVENT_NEWS')">이벤트&amp;뉴스</a></li>
      <li class="li07"><a @click="onMenuSelected('SURVEY')">설문조사</a></li>
    </ul>
    <!--//메뉴 01-->
    <!--메뉴 02-->
    <ul class="lnb-menu02">
      <li><a @click="onMenuSelected('ALARM')"><span>알림내역</span></a></li>
      <!-- <li><a @click="onMenuSelected('BENEFIT')"><span>회원혜택</span></a></li>            -->
      <li><a @click="onMenuSelected('SERVICE_CENTER')"><span>고객센터</span></a></li>
      <li><a @click="onMenuSelected('INFORMATION')"><span>이용안내</span></a></li>
    </ul>
    <!--//메뉴 02-->
    <!-- 메뉴 03-->
    <ul class="lnb-menu03">
      <li><a href="#" @click="openWeb('http://www.gong-cha.co.kr/brand/')"><img src="@/assets/img/link-lnb-gongcha.png"
                                                                                alt="공차 홈페이지"></a></li>
      <li><a href="#" @click="openWeb('https://www.facebook.com/GongCha.Korea')"><img src="@/assets/img/link-lnb-fb.png"
                                                                                      alt="페이스북"></a></li>
      <li><a href="#" @click="openWeb('https://www.instagram.com/gongcha.official/')"><img
        src="@/assets/img/link-lnb-insta.png" alt="인스타그램"></a></li>
    </ul>
    <!--//메뉴 03-->
  </div>
</template>
<script>
import {LoginConfig} from '@/store/Constraints';
import {FindShowTabType, GiftShopTabType, LocalStorageConfig, MenuAuth} from "@/components/AppConstants";
import {isAndroid} from "mobile-device-detect";


export default {
  name: "menu-left",
  props: ['open_menu'],
  mounted() {
    // if(this.loginState)
    //   console.log('MenuLeft.mounted -> memberInfo : ',this.memberInfo);
  },
  computed: {

    mainInfo: function () {
      return this.$store.getters[LoginConfig.MAIN_DATA]
    }
  },
  methods: {
    onMenuSelected: function (menu) {
      // console.log('MenuLeft.methods.onMenuSelected',menu);
      // this.$emit('onMenuSelected',menu);
      switch (menu) {
        case MenuAuth.Order.name:

          // 로그인 및 위치정보 동의여부 확인
          if (this.memberInfo && this.memberInfo.positionAgree != "Y") {
            // 팝업
            this.openPopAlert("confirm01")
          } else {
            // 이동할 페이지 경로 지정
            let path = this.isOrderEnabled ? '/order/store' : ''
            path = this.isDeliveryEnabled ? '/order/delivery' : path
            path = this.isOrderEnabled && this.isDeliveryEnabled ? '/order' : path;

            if (isAndroid) {
              // 안드로이드
              try {
                // 안드로이드 함수 호출
                let result = window.App.getGPSYn();

                // 성공
                if (result) {
                  this.checkLoginAndPush(path, MenuAuth.Order);
                }
              } catch (error) {
                // 안드로이드 호출 예외
                this.checkLoginAndPush(path, MenuAuth.Order);
              }
            } else {
              // WEB & IOS
              this.checkLoginAndPush(path, MenuAuth.Order);
            }
          }

          break;
        case MenuAuth.GiftShop.name:
          // this.$router.push('/giftshop')
          localStorage.setItem(LocalStorageConfig.GiftShopTab, GiftShopTabType.Default)
          this.checkLoginAndPush('/giftshop', MenuAuth.GiftShop)
          break;

        case MenuAuth.FindStore.name:                    // FindStore:'FIND_STORE',             //Side,main menu - 매장찾기
          localStorage.setItem(LocalStorageConfig.FindShopTab, FindShowTabType.Near)
          // 회원 위치정보 동의 여부 확인
          if (this.memberInfo && this.memberInfo.positionAgree != "Y") {
            // 팝업
            this.openPopAlert("confirm02")
            return;
          }
          this.checkLoginAndPush('/findShopMain', MenuAuth.FindStore)
          break;
        case MenuAuth.ShowMenu.mame:                     // ShowMenu:'SHOW_MENU',               //Side menu - 메뉴보기
          break;

        case MenuAuth.OrderHistory.name:                 // OrderHistory:'ORDER_HISTORY',       //Side menu - 주문내역
          this.checkLoginAndPush('/order/history', MenuAuth.OrderHistory);
          break;

        case MenuAuth.EventNews.name:                    // EventNews:'EVENT_NEWS',             //Side,main menu - 이벤트&뉴스
          localStorage.setItem(LocalStorageConfig.EventNewsTab, 'event')
          this.checkLoginAndPush('/eventnews', MenuAuth.EventNews)
          break;

        case MenuAuth.Alarm.name:                        // Alarm:'ALARM',                      //Side menu - 알림내역
          this.checkLoginAndPush('/notice', MenuAuth.Alarm)
          break;
        case MenuAuth.Benefit.name:                      // Benefit:'BENEFIT',                  //Side menu - 회원혜택
          // this.$router.push('/member/benefit')
          this.checkLoginAndPush('/member/benefit', MenuAuth.Benefit)
          break;
        case MenuAuth.ServiceCenter.name:                // ServiceCenter:'SERVICE_CENTER',     //Side menu - 고객센터
          this.checkLoginAndPush('/customer', MenuAuth.ServiceCenter)
          break;
        case MenuAuth.Information.name:                  // Information:'INFORMATION',          //Side menu - 이용안내
          this.checkLoginAndPush('/guide', MenuAuth.Information)
          break;


        case MenuAuth.Stamp.name:                        // Stamp:'STAMP',                      //menu - 스탬프
          // this.$router.push('/Stamp')
          this.checkLoginAndPush('/Stamp', MenuAuth.Stamp)
          break;
        // Coupon:'COUPON',                    //menu - 쿠폰
        // PrepaidCard:'PREPAID_CARD'          //menu - 공차카드
        case MenuAuth.Settings.name:
          this.checkLoginAndPush('/settings', MenuAuth.Settings)
          break;
        case MenuAuth.Survey.name:
          this.checkLoginAndPush('/survey', MenuAuth.Survey)

      }
      // this.hideMenu();
    },
    checkLoginAndPush(route, Menu) {
      console.log('MenuLeft.methods.checkLoginAndPush - ', route, Menu);

      // console.log('MenuLeft.methods.checkLoginAndPush - checkLogin : ',checkLogin());

      this.hideMenu();
      if (Menu.need_login && this.loginState != true) {
        this.openPopAlert('login-alert')

        return;
      }
      this.$router.push(route)
    },
    checkLoginAndPopup(popup, Menu) {
      console.log('MenuLeft.methods.checkLoginAndPopup - ', popup, Menu);

      this.hideMenu();
      if (Menu.need_login && this.loginState != true) {
        this.openPopAlert('login-alert')

        return;
      }
      this.openPop(popup);
    },

    // hideMenu:function(){
    //     console.log('MenuLeft.hideMenu');
    //     hideMenu();
    // },
  }
}
</script>




// WEBPACK FOOTER //
// src/components/common/menuheader/MenuLeft.vue